'use es6';

import UIPanel from 'UIComponents/panel/UIPanel';
import styled from 'styled-components';
import { SATURN_LAYER } from 'HubStyleTokens/sizes';
const StyledUniversalSidebarPanel = styled(UIPanel).withConfig({
  displayName: "StyledUniversalSidebarPanel",
  componentId: "sc-1ryb9uu-0"
})(["&&&{min-width:316px;width:25vw !important;max-width:477px;z-index:", ";@media screen and (min-width:1920px){min-width:477px;}}"], SATURN_LAYER);
export default StyledUniversalSidebarPanel;